import React from 'react';
import { connect } from 'react-redux';

import FinishedDiagnostic from './finishedDiagnostic.jsx';
import LandingPage from './landingPage.jsx';
import PlayDiagnosticQuestion from './sentenceCombining.jsx';
import PlayTitleCard from './titleCard.tsx';

import { CLIP_SOURCE_TYPE, clipSource } from '../../../Shared/libs/speech/clipSource';
import { ReadAloudSource } from '../../../Shared/components/readAloud/readAloudSource';
import { saveSession, } from '../../utils/saveSession'
import {
  CLICK,
  KEYDOWN,
  KEYPRESS,
  LanguageSelectionPage,
  MOUSEDOWN,
  MOUSEMOVE,
  ProgressBar,
  SCROLL,
  SmartSpinner,
  TeacherPreviewMenuButton,
  VISIBILITYCHANGE,
  getParameterByName,
  hasTeacherPreview
} from '../../../Shared/index';
import {
  clearData,
  loadData,
  nextQuestion,
  resumePreviousDiagnosticSession,
  setCurrentQuestion,
  setDiagnosticID,
  storeResponseInAttempts,
  updateCurrentQuestion,
  updateLanguage
} from '../../actions/diagnostics.js';
import SessionActions from '../../actions/sessions.js';
import i18n from '../../../Shared/libs/translations/i18n';
import {
  answeredQuestionCount,
  getProgressPercent,
  questionCount
} from '../../libs/calculateProgress';
import { ENGLISH, defaultLanguages, languageToLocale } from '../../../Shared/utils/languageList';
import PlayFillInTheBlankQuestion from '../fillInBlank/playFillInTheBlankQuestion';

const TITLE_CARD_TYPE = "TL"
const TURK = 'turk'

export class ELLStudentDiagnostic extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      saved: false,
      sessionID: this.getSessionId(),
      hasOrIsGettingResponses: false,
      startTime: Date.now(),
      isIdle: false,
      timeTracking: {},
      languageInitialized: false
    }
  }

  componentDidMount() {
    const { dispatch, match, lessons } = this.props
    const { sessionID, } = this.state
    const { params } = match;
    const { diagnosticID } = params;

    document.title = `Quill.org | ${lessons.data[diagnosticID].name}`

    dispatch(clearData());
    dispatch(setDiagnosticID({ diagnosticID: match.params.diagnosticID, }))
    if (sessionID) {
      const { timeTracking, } = this.state
      SessionActions.get(sessionID, (data) => {
        if (data) {
          this.updateLanguage(data.language);
          this.setState({
            session: data,
            timeTracking: data.timeTracking || timeTracking,
            languageInitialized: true
          });
        } else {
          this.handleSetLanguageInitializedTrue()
        }
      });
    } else {
      this.handleSetLanguageInitializedTrue()
    }
    const data = this.getFetchedData()
    const action = loadData(data);
    dispatch(action);

    window.addEventListener(KEYDOWN, this.resetTimers)
    window.addEventListener(MOUSEMOVE, this.resetTimers)
    window.addEventListener(MOUSEDOWN, this.resetTimers)
    window.addEventListener(CLICK, this.resetTimers)
    window.addEventListener(KEYPRESS, this.resetTimers)
    window.addEventListener(SCROLL, this.resetTimers)
    window.addEventListener(VISIBILITYCHANGE, this.setIdle)
  }

  componentDidUpdate(prevProps) {
    const { timeTracking, } = this.state

    const { previewMode, skippedToQuestionFromIntro, questionToPreview, playDiagnostic, } = this.props;

    if(prevProps.skippedToQuestionFromIntro !== skippedToQuestionFromIntro && previewMode && questionToPreview) {
      this.startActivity();
    }
    if (prevProps.playDiagnostic.answeredQuestions.length !== playDiagnostic.answeredQuestions.length) {
      this.saveSessionData({ ...playDiagnostic, timeTracking, });
    }
  }

  componentWillUnmount() {
    window.removeEventListener(KEYDOWN, this.resetTimers)
    window.removeEventListener(MOUSEMOVE, this.resetTimers)
    window.removeEventListener(MOUSEDOWN, this.resetTimers)
    window.removeEventListener(CLICK, this.resetTimers)
    window.removeEventListener(KEYPRESS, this.resetTimers)
    window.removeEventListener(SCROLL, this.resetTimers)
    window.removeEventListener(VISIBILITYCHANGE, this.setIdle)
  }

  handleSetLanguageInitializedTrue() {
    this.setState({ languageInitialized: true })
  }

  determineActiveStepForTimeTracking(playDiagnostic) {
    const { currentQuestion, answeredQuestions, } = playDiagnostic

    if (!currentQuestion) { return 'landing' }

    const finishedTitleCards = answeredQuestions.filter(q => q.type === TITLE_CARD_TYPE)
    const finishedQuestions = answeredQuestions.filter(q => q.type !== TITLE_CARD_TYPE)

    if (currentQuestion.type === TITLE_CARD_TYPE) { return `title_card_${finishedTitleCards.length + 1}`}
    if (currentQuestion.type !== TITLE_CARD_TYPE) { return `prompt_${finishedQuestions.length + 1}`}
  }

  resetTimers = (e=null) => {
    const now = Date.now()
    this.setState((prevState, props) => {
      const { startTime, timeTracking, isIdle, inactivityTimer, completedSteps, } = prevState
      const { playDiagnostic, } = props
      const activeStep = this.determineActiveStepForTimeTracking(playDiagnostic)

      if (inactivityTimer) { clearTimeout(inactivityTimer) }

      let elapsedTime = now - startTime
      if (isIdle || !playDiagnostic.questionSet) {
        elapsedTime = 0
      }
      const newTimeTracking = {...timeTracking, [activeStep]: (timeTracking[activeStep] || 0) + elapsedTime}
      const newInactivityTimer = setTimeout(this.setIdle, 30000);  // time is in milliseconds (1000 is 1 second)

      return { timeTracking: newTimeTracking, isIdle: false, inactivityTimer: newInactivityTimer, startTime: now, }
    })

    return Promise.resolve(true);
  }

  setIdle = () => { this.resetTimers().then(() => this.setState({ isIdle: true })) }

  getPreviousSessionData = () => {
    const { session, } = this.state
    return session;
  }

  resumeSession = (data) => {
    const { dispatch, } = this.props
    if (data) {
      dispatch(resumePreviousDiagnosticSession(data));
    }
  }

  getSessionId = () => {
    let sessionID = getParameterByName('student');
    if (sessionID === 'null') {
      sessionID = undefined;
    }
    return sessionID;
  }

  saveSessionData = (lessonData) => {
    const { sessionID, } = this.state

    if (sessionID) {
      SessionActions.update(sessionID, lessonData);
    }
  }

  isTurkSession = () => {
    const { match, } = this.props
    return match.path.includes(TURK)
  }

  handleStateUpdate = (newState) => {
    this.setState(newState)
  }

  saveToLMS = () => {
    const { sessionID, timeTracking, } = this.state
    const { playDiagnostic, match } = this.props
    saveSession(sessionID, timeTracking, playDiagnostic, match, this.isTurkSession(), this.handleStateUpdate)
  }

  submitResponse = (response) => {
    const { dispatch, } = this.props

    const action = storeResponseInAttempts(response);
    dispatch(action);
  }

  renderQuestionComponent = () => {
    const { playDiagnostic, dispatch, match, translate, previewMode } = this.props
    const { params } = match;
    const { diagnosticID } = params;

    const isLastQuestion = playDiagnostic.unansweredQuestions.length === 0
    const language = this.language()
    const languageLocale = language && language !== ENGLISH && languageToLocale[language]

    let component
    if (playDiagnostic.currentQuestion.type === 'SC') {
      component = (<PlayDiagnosticQuestion
        diagnosticID={diagnosticID}
        dispatch={dispatch}
        isLastQuestion={isLastQuestion}
        key={playDiagnostic.currentQuestion.data.key}
        language={language}
        languageLocale={languageLocale}
        marking="diagnostic"
        nextQuestion={this.nextQuestion}
        previewMode={previewMode}
        question={playDiagnostic.currentQuestion.data}
        translate={translate}
      />);
    } else if (playDiagnostic.currentQuestion.type === TITLE_CARD_TYPE) {
      component = (
        <PlayTitleCard
          currentKey={playDiagnostic.currentQuestion.data.key}
          data={playDiagnostic.currentQuestion.data}
          dispatch={dispatch}
          handleContinueClick={this.nextQuestion}
          isLastQuestion={isLastQuestion}
          key={playDiagnostic.currentQuestion.data.key}
          language={language}
          languageLocale={languageLocale}
          previewMode={previewMode}
          translate={translate}
        />
      );
    } else if (playDiagnostic.currentQuestion.type === 'FB') {
      component = (
        <PlayFillInTheBlankQuestion
          currentKey={playDiagnostic.currentQuestion.data.key}
          diagnosticID={diagnosticID}
          dispatch={dispatch}
          key={playDiagnostic.currentQuestion.data.key}
          language={language}
          languageLocale={languageLocale}
          nextQuestion={this.nextQuestion}
          previewMode={previewMode}
          question={playDiagnostic.currentQuestion.data}
          translate={translate}
        />
      );
    }
    return component
  }

  startActivity = () => {
    const { dispatch, previewMode, skippedToQuestionFromIntro, questionToPreview } = this.props

    const data = this.getFetchedData()
    const action = loadData(data);
    dispatch(action);
    // when user skips to question from the landing page, we set the current question here in this one instance and default lanugage to English
    if(previewMode && skippedToQuestionFromIntro && questionToPreview) {
      if(!this.language()) {
        this.updateLanguage(ENGLISH);
      }
      const action = setCurrentQuestion(questionToPreview);
      dispatch(action);
    } else {
      const next = nextQuestion();
      dispatch(next);
    }
  }

  nextQuestion = () => {
    const { dispatch, playDiagnostic, previewMode } = this.props;
    const { unansweredQuestions } = playDiagnostic;

    this.resetTimers()
    // we set the current question here; otherwise, the attempts will be reset if the next question has already been answered
    if(previewMode) {
      const question = unansweredQuestions[0].data;
      const action = setCurrentQuestion(question);
      dispatch(action);
    } else {
      const next = nextQuestion();
      dispatch(next);
    }
  }

  getLesson = () => {
    const { lessons, match } = this.props;
    const { params } = match;
    const { diagnosticID } = params;
    return lessons.data[diagnosticID];
  }

  markIdentify = (bool) => {
    const { dispatch, } = this.props
    const action = updateCurrentQuestion({ identified: bool, });
    dispatch(action);
  }

  getFetchedData = () => {
    const lesson = this.getLesson()
    if (lesson) {
      const filteredQuestions = lesson.questions.filter((ques) => {
        return this.props[ques.questionType] ? this.props[ques.questionType].data[ques.key] : null  // eslint-disable-line react/destructuring-assignment
      });
      // this is a quickfix for missing questions -- if we leave this in here
      // long term, we should return an array through a forloop to
      // cut the time from 2N to N
      return filteredQuestions.map((questionItem) => {
        const questionType = questionItem.questionType;
        const key = questionItem.key;
        const question = this.props[questionType].data[key]; // eslint-disable-line react/destructuring-assignment
        question.key = key;
        question.attempts = question.attempts ? question.attempts : []
        let type
        switch (questionType) {
          case 'questions':
            type = 'SC'
            break
          case 'fillInBlank':
            type = 'FB'
            break
          case 'titleCards':
            type = TITLE_CARD_TYPE
            break
        }
        return { type, data: question, };
      });
    }
  }

  updateLanguage = (language) => {
    const { dispatch, } = this.props
    i18n.changeLanguage(language);
    dispatch(updateLanguage(language));
  }

  language = () => {
    const { playDiagnostic, } = this.props

    return playDiagnostic.language;
  }

  landingPageHtml = () => {
    const { lessons, match } = this.props;
    const { data } = lessons;
    const { params } = match;
    const { diagnosticID } = params;
    return data[diagnosticID].landingPageHtml
  }

  getQuestionCount = () => {
    const { playDiagnostic, } = this.props
    if (playDiagnostic.questionSet && playDiagnostic.questionSet.length) {
      const { questionSet } = playDiagnostic
      return questionSet.filter(question => question.type !== 'TL').length
    }
  }

  renderProgressBar = () => {
    const { playDiagnostic, } = this.props
    if (!playDiagnostic.currentQuestion) { return }

    const calculatedAnsweredQuestionCount = answeredQuestionCount(playDiagnostic)

    const currentQuestionIsTitleCard = playDiagnostic.currentQuestion.type === TITLE_CARD_TYPE
    const currentQuestionIsNotFirstQuestion = calculatedAnsweredQuestionCount !== 0

    const displayedAnsweredQuestionCount = currentQuestionIsTitleCard && currentQuestionIsNotFirstQuestion ? calculatedAnsweredQuestionCount + 1 : calculatedAnsweredQuestionCount

    const progressPercent = getProgressPercent(playDiagnostic);
    const totalQuestionCount = questionCount(playDiagnostic);



    return (
      <ProgressBar
        answeredQuestionCount={displayedAnsweredQuestionCount > totalQuestionCount ? totalQuestionCount : displayedAnsweredQuestionCount}
        label='questions'
        percent={progressPercent}
        questionCount={totalQuestionCount}
      />
    )
  }

  render() {
    const { error, saved, languageInitialized } = this.state
    const { dispatch, match, playDiagnostic, translate, previewMode, isOnMobile, handleTogglePreview } = this.props;
    const { params } = match;
    const { diagnosticID } = params;

    const studentSession = getParameterByName('student', window.location.href);
    const language = this.language()
    const languageLocale = language && language !== ENGLISH && languageToLocale[language]

    let component;
    const minusHowMuch = language ? 'minus-nav-and-footer' : 'minus-nav'

    if (playDiagnostic.currentQuestion) {
      component = this.renderQuestionComponent();
    } else if (playDiagnostic.answeredQuestions.length > 0 && playDiagnostic.unansweredQuestions.length === 0) {
      component = (<FinishedDiagnostic
        error={error}
        language={language}
        languageLocale={languageLocale}
        saved={saved}
        saveToLMS={this.saveToLMS}
        translate={translate}
      />);
    } else if (playDiagnostic.language && !previewMode) {
      component = (<LandingPage
        begin={this.startActivity}
        diagnosticID={diagnosticID}
        landingPageHtml={this.landingPageHtml()}
        language={language}
        languageLocale={languageLocale}
        resumeActivity={this.resumeSession}
        session={this.getPreviousSessionData()}
        translate={translate}

      />);
    } else if (languageInitialized) {
      component = (<LanguageSelectionPage
        beginActivity={this.startActivity}
        dispatch={dispatch}
        isDiagnosticActivity={true}
        languages={defaultLanguages}
        previewMode={previewMode}
        questionCount={this.getQuestionCount()}
        setLanguage={this.updateLanguage}
      />);
    } else {
      component = (<SmartSpinner key="step2" message='Loading Your Lesson 50%' />);
    }
    return (
      <div className="ell-diagnostic-container">
        {isOnMobile && (!studentSession || hasTeacherPreview()) && <TeacherPreviewMenuButton containerClass="is-on-mobile" handleTogglePreview={handleTogglePreview} />}
        {this.renderProgressBar()}
        <div className="student-container student-container-diagnostic">
          <ReadAloudSource source={clipSource(CLIP_SOURCE_TYPE.ACTIVITY, diagnosticID)}>{component}</ReadAloudSource>
        </div>
      </div>
    );
  }
}

function select(state) {
  return {
    questions: state.questions,
    playDiagnostic: state.playDiagnostic,
    fillInBlank: state.fillInBlank,
    sessions: state.sessions,
    lessons: state.lessons,
    titleCards: state.titleCards
  };
}
export default connect(select)(ELLStudentDiagnostic);
